export default __webpack_public_path__ + "static/media/filter.242a0573.png";